import { useEffect, useMemo, useReducer } from 'react';
import { api } from '../lib/api';
import { TraceViewsClient, traceViewBrowserStorage, traceViewScope } from '../lib/savedTraceViews';
import { useAuthStore } from '../store/authStore';

export function useSavedTraceViews() {
  const user = useAuthStore((state) => state.user);
  const scope = traceViewScope(user);
  const [, update] = useReducer((value: number) => value + 1, 0);
  const client = useMemo(() => new TraceViewsClient(async (method, url, body, signal, expectedScope) => {
    const assertScope = () => {
      if (traceViewScope(useAuthStore.getState().user) !== expectedScope) throw new Error('Account changed');
    };
    assertScope();
    const response = await api.request({ method, url, data: body, signal,
      headers: method === 'GET' ? undefined : {
        'Content-Type': 'application/json',
        // The server compares this reviewed scope with its freshly authenticated owner/workspace.
        'x-saved-trace-view-scope': expectedScope,
      },
      // Runs after auth interceptors, immediately before dispatch. Never send a queued import under a new account.
      transformRequest: [(data: unknown) => { assertScope(); return data === undefined ? undefined : JSON.stringify(data); }],
    });
    assertScope();
    return response.data.data;
  }, () => traceViewScope(useAuthStore.getState().user), update,
  traceViewBrowserStorage()), []);
  useEffect(() => {
    client.setScope(scope);
    if (scope) void client.list();
    return () => client.dispose();
  }, [client, scope]);
  return { client, scope, user, ...client.state };
}
